module.exports = __webpack_public_path__ + "img/wealthking-inv.02633278.png";